import {TaxonomyFieldsMap, TaxonomyMapping, TaxonomyType} from '../../taxonomy/taxonomy.types';
import Subject from '../../../utils/pubsub/subject';
import {CLPromiseRef} from '../shared.types';

const taxonomyPromise: CLPromiseRef<TaxonomyMapping> = {
  current: null,
};

const taxonomyFieldsPromise: CLPromiseRef<TaxonomyFieldsMap> = {
  current: null,
};

const taxonomyMappingsSubject = new Subject<TaxonomyMapping>({
  [TaxonomyType.Location]: {},
  [TaxonomyType.Product]: {},
  [TaxonomyType.Content]: {},
  [TaxonomyType.Metric]: {},
  [TaxonomyType.FirstParty]: {},
});

export {taxonomyMappingsSubject, taxonomyFieldsPromise, taxonomyPromise};
